import React, { useState } from 'react';

/**
 * Slim promise bar for a promo carried in from a ?coupon= link — either one the coupon engine
 * cannot express (`manualPromos`) or a real coupon that only shows up at checkout
 * (`couponBanners`).
 *
 * Pinned to the bottom rather than the top because the navbar is `fixed-top` — anything placed
 * above `.site-content` in normal flow ends up underneath it. Dismissible so it can never sit
 * on top of a checkout button for good; the same promise is repeated on the confirmation page,
 * so dismissing it loses nothing.
 */
const PromoBanner = ({ message }) => {
  const [dismissed, setDismissed] = useState(false);

  if (!message || dismissed) {
    return null;
  }

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1030,
        background: '#ECF4ED',
        borderTop: '3px solid var(--secondary-color)',
        color: 'var(--primary-color)',
        padding: '12px 80px 12px 48px',
        textAlign: 'center',
        fontWeight: 600,
        boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.08)',
      }}
    >
      <span>{message}</span>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
        style={{
          position: 'absolute',
          // Left, not right: the support chat bubble is fixed to the bottom-right corner and
          // would sit on top of this.
          left: '12px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          color: 'var(--primary-color)',
          fontSize: '22px',
          lineHeight: 1,
          cursor: 'pointer',
        }}
      >
        &times;
      </button>
    </div>
  );
};

export default PromoBanner;
